import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import MedicationOutlinedIcon from '@mui/icons-material/MedicationOutlined';
import BabyChangingStationOutlinedIcon from '@mui/icons-material/BabyChangingStationOutlined';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';

// UI Display Constants for consistent labeling across components
// This centralizes display labels that appear in multiple UI locations

export const UI_LABELS = {
  INCIDENT_SECTION: {
    emoji: null,
    iconComponent: AutoAwesomeOutlinedIcon,
    label: "Important Moment",
    description: "Log moments, challenges, or milestones",
    pluralLabel: "Important Moments", // For filters and headers
    pluralLabelLowercase: "important moments", // For inline text
  },

  // Future: could add other UI sections here
  DAILY_LOG_SECTION: {
    emoji: null,
    iconComponent: DescriptionOutlinedIcon,
    label: "Daily Log",
    description: "Rich daily log with photos, videos & templates",
  },

  DAILY_HABITS_SECTION: {
    emoji: null,
    iconComponent: CalendarMonthOutlinedIcon,
    label: "Daily Habits",
    description: "Track mood, sleep, nutrition, progress, and other daily care data",
  },

  MEDICATION_SECTION: {
    emoji: null,
    iconComponent: MedicationOutlinedIcon,
    label: "Medication",
    description: "Log medication given",
  },

  DIAPER_SECTION: {
    emoji: null,
    iconComponent: BabyChangingStationOutlinedIcon,
    label: "Diaper",
    description: "Log diaper changes and results",
  },

  Messages: {
    emoji: null,
    iconComponent: ChatBubbleOutlineRoundedIcon,
    label: "Messages",
    description: "Securely communicate with your care circle",
  },
};

// Helper functions to get display info
export const getIncidentDisplayInfo = () => UI_LABELS.INCIDENT_SECTION;
export const getMessagesDisplayInfo = () => UI_LABELS.Messages;
export const getDailyLogDisplayInfo = () => UI_LABELS.DAILY_LOG_SECTION;
export const getDailyHabitsDisplayInfo = () => UI_LABELS.DAILY_HABITS_SECTION;
export const getMedicationDisplayInfo = () => UI_LABELS.MEDICATION_SECTION;
export const getDiaperDisplayInfo = () => UI_LABELS.DIAPER_SECTION;
